/*Recurso: Decisions - Servicio de lectura del API: Verifica la autenticación del usuario obteniendo clave y contraseña
  Tareas:
    GetSummaryPxF              //*RD
    GetDetailbyProcess         //*RD   
    GetRateProposal            //*RD   
    UpdateRateProposal         //*RD  
    SendRateProposal           //*RD
*/
import axios from "axios";
//import {IGetSummaryPxF} from "./decisions.modelo";
//import {IGetDetailbyProcess} from "./decisions.modelo";

const API_URL = process.env.REACT_APP_API_URL + 'Decisions/';

  //se genera una función por cada tarea del recurso api

    //tarea: GetSummaryPxF/es
    const cargaGetSummaryPxF = async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetSummaryPxF/es',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetSummaryPxF/es', 'method: post',
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    //tarea: GetDetailbyProcess/es/id  
    const cargaGetDetailbyProcess = async (token:any, id:any) => {
        //console.log ('***API: ' + API_URL + 'GetDetailbyProcess/es/'+id, {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetDetailbyProcess/es/'+id,  'method: post',
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

    //tarea: GetRateProposal  
    const cargaGetRateProposal  = async (token:any, body:any) => {
        //console.log ('***API: ' + API_URL + 'GetRateProposal/es', body,  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetRateProposal/es', body, 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
      };

    //tarea: UpdateRateProposal  
    const cargaUpdateRateProposal  = async (token:any, body:any) => {
        //console.log ('***API: ' + API_URL + 'UpdateRateProposal/es', body,  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'UpdateRateProposal/es', body, 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };    

    //tarea: SendRateProposal  
    const cargaSendRateProposal  = async (token:any, body:any) => {
        //console.log ('***API: ' + API_URL + 'SendRateProposal', body,  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'SendRateProposal', body, 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };      

    /* const cargaGetAllProcessByFrequency= async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetAllProcessByFrequency/es',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetAllProcessByFrequency/es', 'method: post', 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    }; */

const decisionService = {
    cargaGetSummaryPxF: cargaGetSummaryPxF,
    cargaGetDetailbyProcess: cargaGetDetailbyProcess,
    cargaGetRateProposal: cargaGetRateProposal,
    cargaUpdateRateProposal: cargaUpdateRateProposal,
    cargaSendRateProposal: cargaSendRateProposal,
    //cargaGetAllProcessByFrequency: cargaGetAllProcessByFrequency,
};

export default decisionService;
